
import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    title: 'Games',
    rushMidTitle: 'Rush Mid',
    rushMidDescription: 'Turn-based PvP for skins: gear up and outplay your rival',
    rushMidCta: 'Rush the mid',
    rouletteTitle: 'Russian Roulette',
    rouletteDescription: 'R8 cylinder, last one standing takes the bank',
    rouletteCta: 'Play',
    caseBattlesTitle: 'Case Battles',
    caseBattlesDescription: 'Test your luck against other players',
    contractsTitle: 'Contracts',
    contractsDescription: 'Exchange items for better ones',
    upgradeTitle: 'Upgrade',
    upgradeDescription: 'Upgrade items with a chance for rare skins',
    shopTitle: 'Shop',
    shopDescription: 'Buy items',
    comingSoon: 'Coming Soon',
    maintenanceBadge: 'Updating…',
    caseBattlesCta: 'Fight',
    contractsCta: 'Exchange',
    upgradeCta: 'Upgrade',
    shopCta: 'Open',
  },
  ru: {
    title: 'Игры',
    rushMidTitle: 'Rush Mid',
    rushMidDescription: 'Пошаговый PvP за скины: закупись и переиграй соперника',
    rushMidCta: 'Зарашить мид',
    rouletteTitle: 'Русская рулетка',
    rouletteDescription: 'Барабан R8, выживший забирает банк',
    rouletteCta: 'Играть',
    caseBattlesTitle: 'Case Battles',
    caseBattlesDescription: 'Проверь удачу против других игроков',
    contractsTitle: 'Контракты',
    contractsDescription: 'Обменивай предметы на более ценные',
    upgradeTitle: 'Upgrade',
    upgradeDescription: 'Улучшай предметы с шансом на редкие скины',
    shopTitle: 'Магазин',
    shopDescription: 'Покупай предметы',
    comingSoon: 'Скоро',
    maintenanceBadge: 'Обновление…',
    caseBattlesCta: 'В бой',
    contractsCta: 'Обменять',
    upgradeCta: 'Улучшить',
    shopCta: 'Открыть',
  },
  uz: {
    title: 'Oʻyinlar',
    rushMidTitle: 'Rush Mid',
    rushMidDescription: "Skinlar uchun navbatma-navbat PvP: qurollan va raqibingni ort",
    rushMidCta: 'Midni rush qilish',
    rouletteTitle: 'Rus ruletkasi',
    rouletteDescription: "R8 barabani, omon qolgan bankni oladi",
    rouletteCta: 'Oʻynash',
    caseBattlesTitle: 'Case Battles',
    caseBattlesDescription: 'Boshqa oʻyinchilarga qarshi omadingizni sinab koʻring',
    contractsTitle: 'Kontraktlar',
    contractsDescription: 'Buyumlarni qimmatroqlariga almashtiring',
    upgradeTitle: 'Upgrade',
    upgradeDescription: 'Buyumlarni kamyob skinlarga yaxshilash imkoniyati bilan',
    shopTitle: 'Doʻkon',
    shopDescription: 'Buyumlarni sotib oling',
    comingSoon: 'Tez kunda',
    maintenanceBadge: 'Yangilanmoqda…',
    caseBattlesCta: 'Jang',
    contractsCta: 'Almashtirish',
    upgradeCta: 'Yaxshilash',
    shopCta: 'Ochish',
  },
  fa: {
    title: 'بازی‌ها',
    rushMidTitle: 'Rush Mid',
    rushMidDescription: 'PvP نوبتی برای اسکین: تجهیز شو و حریفت را ببر',
    rushMidCta: 'بزن به مید',
    rouletteTitle: 'رولت روسی',
    rouletteDescription: 'خشاب R8، آخرین بازمانده بانک را می‌برد',
    rouletteCta: 'بازی کن',
    caseBattlesTitle: 'نبرد کیس',
    caseBattlesDescription: 'شانست را مقابل بازیکنان دیگر امتحان کن',
    contractsTitle: 'قراردادها',
    contractsDescription: 'آیتم‌ها را با آیتم بهتر عوض کن',
    upgradeTitle: 'ارتقا',
    upgradeDescription: 'آیتم‌ها را ارتقا بده و شانس اسکین کمیاب بگیر',
    shopTitle: 'فروشگاه',
    shopDescription: 'آیتم بخر',
    comingSoon: 'به‌زودی',
    maintenanceBadge: 'در حال به‌روزرسانی…',
    caseBattlesCta: 'بجنگ',
    contractsCta: 'عوض کن',
    upgradeCta: 'ارتقا بده',
    shopCta: 'باز کن',
  },
  pt: {
    title: 'Jogos',
    rushMidTitle: 'Rush Mid',
    rushMidDescription: 'PvP por turnos valendo skins: equipe-se e supere o rival',
    rushMidCta: 'Rushar o mid',
    rouletteTitle: 'Roleta russa',
    rouletteDescription: 'Tambor do R8, o último de pé leva o banco',
    rouletteCta: 'Jogar',
    caseBattlesTitle: 'Batalhas de caixas',
    caseBattlesDescription: 'Teste sua sorte contra outros jogadores',
    contractsTitle: 'Contratos',
    contractsDescription: 'Troque itens por outros mais valiosos',
    upgradeTitle: 'Upgrade',
    upgradeDescription: 'Faça upgrade de itens com chance de skins raras',
    shopTitle: 'Loja',
    shopDescription: 'Compre itens',
    comingSoon: 'Em breve',
    maintenanceBadge: 'Atualizando…',
    caseBattlesCta: 'Lutar',
    contractsCta: 'Trocar',
    upgradeCta: 'Upgrade',
    shopCta: 'Abrir',
  },
  tr: {
    title: 'Oyunlar',
    rushMidTitle: 'Rush Mid',
    rushMidDescription: 'Skin için sıra tabanlı PvP: kuşan ve rakibini alt et',
    rushMidCta: "Mid'e rush at",
    rouletteTitle: 'Rus ruleti',
    rouletteDescription: 'R8 tamburu, hayatta kalan bankayı alır',
    rouletteCta: 'Oyna',
    caseBattlesTitle: 'Kasa savaşları',
    caseBattlesDescription: 'Diğer oyunculara karşı şansını dene',
    contractsTitle: 'Kontratlar',
    contractsDescription: 'Eşyaları daha değerlileriyle takas et',
    upgradeTitle: 'Upgrade',
    upgradeDescription: 'Nadir skin şansıyla eşyalarını upgrade et',
    shopTitle: 'Mağaza',
    shopDescription: 'Eşya satın al',
    comingSoon: 'Yakında',
    maintenanceBadge: 'Güncelleniyor…',
    caseBattlesCta: 'Savaş',
    contractsCta: 'Takas et',
    upgradeCta: 'Upgrade',
    shopCta: 'Aç',
  },
});
